import { Flex, Typography } from "antd";

import styles from "../PatientSnapshot.module.scss";

const { Text } = Typography;

interface FieldProps {
	label: string;
	value: React.ReactNode;
	span?: boolean;
	tone?: "default" | "alert";
}

export const Field = ({
	label,
	value,
	span,
	tone = "default",
}: FieldProps) => (
	<Flex
		vertical
		className={[
			span ? styles.fieldSpan : undefined,
			tone === "alert" ? styles.alertField : undefined,
		]
			.filter(Boolean)
			.join(" ")}
	>
		<Text className={styles.fieldLabel}>{label}</Text>
		<Text className={styles.fieldValue}>{value}</Text>
	</Flex>
);
